import React from 'react';

export const Button = ({
    children = "Contrate agora",
    onClick,
    type = "button",
    className = "",
    variant = "primary",
    disabled = false,
}) => {

    const getVariantClass = () => {
        if (disabled) {
            return "bg-gray-400 text-white text-sm font-medium rounded-full px-5 py-2 cursor-block";
        }

        if (variant === "primary")
            return "bg-[#FA6300] hover:bg-[#eee6fb] text-white text-sm font-medium rounded-full px-5 py-2 transition-colors duration-300";
        if (variant === "secondary")
            return "bg-[#462A71] hover:bg-[#eee6fb] text-white text-sm font-medium rounded-full px-5 py-2 transition-colors duration-300";
        if (variant === "outline") {
            return "border border-orange-400 text-orange-500 hover:bg-[#FA6300] hover:text-white rounded-full px-5 py-2  text-sm font-medium transition-colors"
        }
        return "";
    };

    return (
        <button
            disabled={disabled}
            type={type}
            onClick={onClick}
            className={`${getVariantClass()} ${className}`}
        >
            {children}
        </button>
    );
};



export const TooltipButton = ({
    tooltip,
    children,
    className = "",
    placement = "top", // 'top', 'bottom', 'left', 'right'
    ...props
}) => {
    const getPlacementClasses = () => {
        switch (placement) {
            case "top":
                return "bottom-full mb-2 left-1/2 -translate-x-1/2";
            case "bottom":
                return "top-full mt-2 left-1/2 -translate-x-1/2";
            case "left":
                return "right-full mr-2 top-1/2 -translate-y-1/2";
            case "right":
                return "left-full ml-2 top-1/2 -translate-y-1/2";
            default:
                return "bottom-full mb-2 left-1/2 -translate-x-1/2";
        }
    };

    return (
        <div className="relative group inline-block">
            <button
                {...props}
                className={`relative z-10 ${className}`}
            >
                {children}
            </button>
            <div
                className={`
          absolute 
          ${getPlacementClasses()} 
          z-20 
          hidden 
          group-hover:flex 
          px-2 py-1 
          bg-black 
          text-white 
          text-xs 
          rounded 
          whitespace-nowrap 
          transition-opacity 
          duration-200 
          group-hover:opacity-100 
          opacity-0
        `}
            >
                {tooltip}
            </div>
        </div>
    );
};